<rid-splitting
  (finished)="$router.navigate(['/mechanics/formule'])"
  [numbers]="[
    [5, 3],
    [1, 4],
    [5, 1],
    [6, 3],
    [3, 1],
  ]"
  class="h-dvh"
/>
